import type { EventCalendarApi } from "@repo/ui/components/reui/event-calendar/event-calendar";
import { DEFAULT_CALENDAR_SLOT_HEIGHT } from "@/features/scheduling/lib/constants";

export type ScheduleView = "week" | "month" | "day";

export interface CalendarSettings {
  slotHeight: number; // px, default 80
}

export const DEFAULT_CALENDAR_SETTINGS: CalendarSettings = {
  slotHeight: DEFAULT_CALENDAR_SLOT_HEIGHT,
};

export interface CalendarEventResource {
  type: "appointment";
  data?: import("@repo/data-store").VisitDto;
  /** Set in overlay mode — which schedule this event belongs to */
  scheduleId?: string;
  /** Whose schedule this slot belongs to, in overlay mode. Identity, not status. */
  scheduleAccent?: import("@/shared/timeline").TimelineAccent;
}

export interface CalendarEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  color?: string;
  /**
   * MIN-251: was `resource` (prior calendar library convention) — renamed to
   * `data` to match ReUI's `CalendarEvent<TData>` generic, since `@repo/ui`'s
   * vendored ReUI event calendar (MIN-251) rides its payload on `data`.
   * `CalendarEventResource` is the `TData` here.
   */
  data?: CalendarEventResource;
}

/**
 * MIN-252: the shared ReUI calendar instance's imperative surface — created
 * inside `ScheduleCalendar` (the only component with the full options/data to
 * mount it) and handed up to the page-level toolbar via an `apiRef`, so
 * Prev/Next/Today (and Today's scroll-to-now) delegate to the SAME instance
 * that renders the day/week grid, rather than reimplementing date math.
 */
export type ScheduleCalendarApi = EventCalendarApi<CalendarEventResource>;
